import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'

export const AgendaSidebarViewsLoader = () => {
    return (
        <Flexbox direction="column" gap={3} fullWidth>
            <Skeleton width="100%" height={20} />
            <AgendaSidebarDottedDivider />
            <Skeleton width="100%" height={20} />
        </Flexbox>
    )
}
